<template>
    <div>
        <top-header v-if="!startedTest"/>
        <div v-if="!startedTest" class="mb-5">
            <div class="container pb-5">
                <h4 class="text-uppercase mt-5 text-primary">Target Type</h4>
                <selection-component :items="testPatternOptions"
                                     v-on:selected="updateSelectedTestPatternId"></selection-component>
                <div class="row my-3 text-muted">
                    <div class="col">
                        <hr>
                    </div>
                    <div class="col-auto">AND</div>
                    <div class="col">
                        <hr>
                    </div>
                </div>

                <h4 class="text-uppercase text-primary">Filter Set</h4>
                <selection-component :items="testTypeOptions" v-on:selected="updateTestTypeId"></selection-component>

                <button type="button" v-on:click="start"
                        class="btn btn-outline-success mt-4 mb-5 text-uppercase responsive-btn">Start
                    <font-awesome-icon icon="play-circle"/>
                </button>
            </div>
        </div>
        <fullscreen ref="fullscreen" @change="fullscreenChange">
            <test-screen v-if="startedTest" :selected-test-pattern-id="selectedTestPatternId" class=""
                         :selected-test-type-id="selectedTestTypeId" :is-full-screen="fullscreen"></test-screen>
        </fullscreen>
        <div class="fullScreenButton transparentBackground" v-if="!fullscreen && startedTest">
            <button type="button" class="btn btn-outline-dark" v-on:click="fullScreen">Full Screen
                <font-awesome-icon icon="arrows-alt"/>
            </button>
            <button type="button" class="btn btn-outline-dark ml-1" v-on:click="stopTest">
                <font-awesome-icon icon="times-circle"/>
            </button>
        </div>

        <bottom-footer v-if="!startedTest"/>
    </div>
</template>

<script>
    import SelectionComponent from './selectionComponent/SelectionComponent';
    import TestScreen from './TestScreen';
    import TopHeader from './TopHeader';
    import BottomFooter from './decorators/BottomFooter';

    export default {
        name: 'StartTest',
        components: {BottomFooter, TopHeader, TestScreen, SelectionComponent},
        data() {
            return {
                startedTest: false,
                fullscreen: true,
                bgc: {
                    backgroundColor: '',
                    color: 'dark_gray',
                },
                selectedTestPatternId: 'Text',
                testPatternOptions: [
                    {id: 'Color', label: 'Colors Only', icon: 'square'},
                    {id: 'Text', label: 'Text', icon: 'font', isSelected: true},
                    {id: 'Nonsense', label: 'Nonsense', icon: 'align-justify'},
                ],
                selectedTestTypeId: 'Medium',
                testTypeOptions: [
                    {id: 'Light', label: 'Light', icon: 'sun'},
                    {id: 'Medium', label: 'Medium', icon: 'lightbulb', isSelected: true},
                    {id: 'Dark', label: 'Dark', icon: 'moon'},
                ],
            };
        },
        methods: {
            updateSelectedTestPatternId(selectionId) {
                this.selectedTestPatternId = selectionId;
            },
            updateTestTypeId(selectionId) {
                this.selectedTestTypeId = selectionId;
            },
            start() {
                this.startedTest = true;
                this.fullScreen();
            },
            stopTest() {
                this.startedTest = false;
            },
            fullScreen() {
                this.$refs.fullscreen.toggle();
            },
            fullscreenChange(fullscreen) {
                this.fullscreen = fullscreen;
            },
        },
    };
</script>

<style lang="scss" scoped>
  .fullScreenButton {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }

  .transparentBackground {
    background: rgba(76, 175, 80, 0.0);
  }

  .selectionTitle {
    font-size: 1.5rem;
  }

  .responsive-btn {
    font-size: 1.8rem;
    /*padding: 1rem;*/
    padding: 1rem 1.5rem 1rem 1.5rem;
  }

  /* Medium devices that are bigger than ipad */
  @media (min-width: 769px) {
    .responsive-btn {
      font-size: 1rem;
      padding: 0.5rem 1rem 0.5rem 1rem;
    }
  }
</style>
